import React from 'react'
import styles from './FormLabels.module.scss'
import type { BaseType } from 'antd/lib/typography/Base'
import { CustomTitle, CustomText } from 'src/components'

interface FormLabelsProps {
  title: string | React.ReactNode
  subtitle?: string
  tag?: React.ReactNode
  url?: string
  thirdLabel?: string
  thirdLabelType?: BaseType
}

const FormLabels: React.FC<FormLabelsProps> = (props) => {
  const { title, ...restProps } = props

  return <div {...restProps}>
    {/* Title */}
    {props.url ? <a rel='noopener noreferrer' href={props.url} className={styles.link}>
      <CustomTitle label={title} type={null} />
    </a> : <CustomTitle label={title} type={null} />}

    {/* Subtitle */}
    {!props.tag ? <CustomText
      label={props.subtitle}
      type={'secondary'}
      className={styles.subtitle}
    /> : <>{props.tag}</>}

    {/* Third Label */}
    {props.thirdLabel && <>
      <br/>
      <CustomText
        label={props.thirdLabel}
        type={props.thirdLabelType || 'secondary'}
        className={styles.subtitle}
      />
    </>}
  </div>
}

export default FormLabels
